export default function Stat_Correlation_Vs_Causality() {
  return <div>Stat_Correlation_Vs_Causality Component</div>;
}
